// Per-device record that the viewer has been through (or skipped) the welcome
// quiz, so we don't nag them again. This is a convenience flag only — the real
// signal that onboarding "worked" is the answers now recorded on their account,
// which is server-side. Browser storage can be absent/cleared/blocked, so every
// access is guarded and failure just means "treat as not-yet-onboarded".
const ONBOARDED_KEY = 'pinion_onboarded';

export const isOnboarded = (): boolean => {
  try {
    return localStorage.getItem(ONBOARDED_KEY) === '1';
  } catch {
    return false;
  }
};

export const markOnboarded = (): void => {
  try {
    localStorage.setItem(ONBOARDED_KEY, '1');
  } catch {
    // Private mode / blocked storage — nothing to do; the quiz simply may be
    // offered again next time, which is harmless.
  }
};
